import _axios from "../../libs/axios";
import moment from "moment";
import { findModuleInMenu } from "../../helpers/Utils";

export default (context) => {
  const M = "admActivity.";
  const isCurricular = !!context.props.config?.curricular;
  const admRegist = findModuleInMenu(context.props.menuItems, "id", "admRegist");

  const dayFields = [
    { key: "hrsMO", label: "main.monday" },
    { key: "hrsTU", label: "main.tuesday" },
    { key: "hrsWE", label: "main.wednesday" },
    { key: "hrsTH", label: "main.thursday" },
    { key: "hrsFR", label: "main.friday" },
    { key: "hrsSA", label: "main.saturday" },
    { key: "hrsSU", label: "main.sunday" }
  ];
  const hourOptions = Array.from({ length: ((18 - 7) * 60) / 5 + 1 }, (_, i) => {
    const totalMinutes = (7 * 60) + (i * 5);
    const hour = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
    const minute = String(totalMinutes % 60).padStart(2, "0");
    const value = `${hour}:${minute}`;
    return { value, label: value };
  });
  const timeSelectOpts = {
    style: "float-label",
    items: hourOptions,
    isMulti: true,
    onMenuOpen: (ctx, selectRef) => {
      if (selectRef?.state?.items?.length === 0) {
        selectRef.setState({ items: hourOptions });
      }
    },
    filterOption: (option, inputValue) => {
      const input = (inputValue || "").trim();
      if (!input) return option?.label?.endsWith(":00");
      return option?.label?.toLowerCase().includes(input.toLowerCase());
    },
    setOutput: (selected) => {
      if (!selected) return null;
      const selectedList = Array.isArray(selected) ? selected : [selected];
      const mapped = selectedList
        .map((s) => {
          const normalized = formatHourValue(s?.value || s?.ID || s?.name || s?.label);
          if (!normalized) return null;
          return { ID: normalized, name: normalized };
        })
        .filter(Boolean);
      return mapped.length > 0 ? mapped : null;
    }
  };
  const normalizeHourValues = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value
        .map((item) => item?.ID || item?.name || item?.value || item?.label || item)
        .filter(Boolean);
    }

    if (typeof value === "string") {
      return value.split(",").map((v) => v.trim()).filter(Boolean);
    }

    return [];
  };

  const formatHourValue = (value) => {
    const parsed = moment(value, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "HH:mm:ss", "HH:mm"], true);
    if (!parsed.isValid()) return null;
    if (parsed.minutes() % 5 !== 0) return null;
    return parsed.format("HH:mm");
  };

  const toHourSelectValue = (value) => {
    return normalizeHourValues(value)
      .map(formatHourValue)
      .filter(Boolean)
      .map((hour) => ({ ID: hour, name: hour }));
  };

  const toHoursCsv = (value) => {
    return normalizeHourValues(value)
      .map(formatHourValue)
      .filter(Boolean)
      .join(",");
  };

  let roles = [];

  _axios.get("admGroup/getTypes")
    .then((r) => {
      roles = r.data.Results;
    });

  return {
    config: {
      hiddenTitle: !!context.props.parentId,
      pageSize: 40,
      remapRow: (d) => {
        if (d.masterId?.label) d.master = d.masterId.label;
        return d;
      }
    },

    actions: {
      create: isCurricular ? false : { reloadGrid: true },
      edit: true,
      delete: true,
      search: !isCurricular,
      export: !isCurricular
    },

    extras: {
      itemsInRowsTable: (!isCurricular && admRegist) ? [
        {
          icon: "simple-icon-people",
          name: `${M}viewRegistrations`,
          onClick: (rowData, ctx) => {
            ctx.props.setDeeplink({
              module: admRegist.to || "/app/admRegist",
              params: [
                {
                  name: "activityPartId",
                  value: { value: rowData.ID, label: rowData.name },
                  type: "select",
                  label: `${M}activityPart`,
                  opts: {
                    style: "float-label",
                    path: "/admActivityParts/get?pick=true&type=act"
                  }
                },
                {
                  name: "status",
                  value: 1,
                  type: "select",
                  label: "main.status",
                  opts: {
                    style: "float-label",
                    isClearable: false,
                    items: [
                      { value: 1, label: "admRegist.statusConfirmed" },
                      { value: 0, label: "admRegist.statusCancelled" },
                      { value: 2, label: "admRegist.statusSuspended" },
                      { value: 3, label: "admRegist.statusExcluded" }
                    ]
                  }
                }
              ],
              type: 0,
              keepFilters: true
            }, ctx.props.history);
          }
        }
      ] : []
    },

    form: {
      cloneable: true,
      remapOne: (r) => {
        if (r.status >= 0) {
          if (r.data.masterId) {
            r.data.masterId = { value: r.data.masterId, label: r.data.masterName };
          }
          dayFields.forEach((d) => {
            r.data[d.key] = toHourSelectValue(r.data[d.key]);
          });
        }
        return r;
      },
      setValuesBeforePost: (values) => {
        if (typeof values.masterId === "object") values.masterId = values.masterId?.value;
        dayFields.forEach((d) => {
          if (!values[d.key]) return;
          values[d.key] = toHoursCsv(values[d.key]);
        });
        return values;
      },
      fields: [
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: isCurricular ? `${M}section` : `${M}shiftScheduleGroup`,
          rules: "required|max:50",
          disabled: isCurricular,
          opts: {
            style: "float-label"
          }
        },
        {
          col: 12,
          name: "masterId",
          value: "",
          type: "select",
          label: `${M}mainTeacher`,
          rules: "required",
          opts: {
            style: "float-label",
            path: "/admStaff/get?pick=true",
            setOutput: (v) => v
          }
        },
        {
          col: 3,
          name: "hrsMO",
          value: "",
          type: "select",
          label: `${M}scheduleMonday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsTU",
          value: "",
          type: "select",
          label: `${M}scheduleTuesday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsWE",
          value: "",
          type: "select",
          label: `${M}scheduleWednesday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsTH",
          value: "",
          type: "select",
          label: `${M}scheduleThursday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsFR",
          value: "",
          type: "select",
          label: `${M}scheduleFriday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsSA",
          value: "",
          type: "select",
          label: `${M}scheduleSaturday`,
          opts: timeSelectOpts
        },
        {
          col: 3,
          name: "hrsSU",
          value: "",
          type: "select",
          label: `${M}scheduleSunday`,
          opts: timeSelectOpts
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "text",
          label: "main.desc",
          rules: "max:150",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 4,
          name: "duration",
          value: "",
          type: "number",
          label: `${M}durationMinutes`,
          rules: "required|numeric",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 4,
          name: "location",
          value: "",
          type: "text",
          label: "main.location",
          rules: "required|max:50",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 4,
          name: "available",
          value: "",
          type: "number",
          label: `${M}availableSlots`,
          rules: "required|numeric",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 6,
          name: "price",
          value: "",
          type: "text",
          label: `${M}price`,
          rules: "numeric",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 6,
          name: "curr",
          value: "",
          type: "select",
          label: `${M}currency`,
          opts: {
            style: "float-label",
            items: [
              { value: "PEN", label: "PEN" },
              { value: "USD", label: "USD" }
            ]
          }
        },
        {
          col: 4,
          name: "fromAge",
          value: "",
          type: "number",
          label: `${M}minAge`,
          rules: "numeric",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 4,
          name: "toAge",
          value: "",
          type: "number",
          label: `${M}maxAge`,
          rules: "numeric",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 4,
          name: "gender",
          value: "*",
          type: "select",
          label: "main.gender",
          rules: "required",
          opts: {
            style: "float-label",
            items: [
              { value: "*", label: "main.all" },
              { value: "M", label: "M" },
              { value: "F", label: "F" }
            ]
          }
        },
        {
          col: 6,
          name: "hasAttendance",
          value: false,
          type: "switch",
          label: `${M}attendanceControl`
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive"
        },
        {
          col: 6,
          name: "externalId",
          value: "",
          type: "text",
          label: "main.externalId",
          rules: "max:15",
          opts: {
            style: "float-label"
          },
          renderIf: () => !isCurricular
        },
        {
          col: 6,
          name: "docUrl",
          value: "",
          type: "dropzone",
          label: "main.attachment",
          rules: "ext:pdf",
          opts: {
            path: () => "/admActivityParts/file",
            accept: ".pdf"
          },
          renderIf: () => !isCurricular
        },
        {
          col: 12,
          name: "ID",
          value: ""
        }
      ],
      detailGrid: () => {
        return context.state.idItemSelected
          ? {
            module: "admActivityMasters",
            parentIdField: "ID",
            embeded: (c) => {
              return {
                config: {
                  pageSize: 40,
                  remap: (list, row) => { list.data.Results = list.data.Results.map(row); return list; },
                  remapRow: (r) => {
                    const rol = roles.find((f) => f.ID === r.alterType);
                    if (rol) r.alterTypeName = rol.name;
                    return r;
                  }
                },

                actions: {
                  create: {
                    reloadGrid: true
                  },
                  edit: {
                    reloadGrid: true
                  },
                  delete: true,
                  print: false,
                  export: false
                },

                filter: {
                  fields: []
                },

                form: {
                  remapOne: (r) => {
                    if (r.status >= 0) {
                      r.data.userId = { value: r.data.userId, label: r.data.userName };
                      r.data.alterType = { value: r.data.alterType, label: roles.find((f) => f.ID === r.data.alterType)?.name || "-" };
                    }
                    return r;
                  },
                  fields: [
                    {
                      col: 12,
                      name: "userId",
                      value: "",
                      type: "select",
                      label: `${M}instructor`,
                      rules: "required",
                      opts: {
                        style: "float-label",
                        path: "/admStaff/get?pick=true"
                      }
                    },
                    {
                      col: 12,
                      name: "role",
                      value: null,
                      type: "text",
                      label: `${M}roleInCourse`,
                      rules: "required",
                      opts: {
                        style: "float-label"
                      }
                    },
                    {
                      name: "alterType",
                      value: "",
                      col: 12,
                      type: "select",
                      label: `${M}roleType`,
                      rules: "required",
                      opts: {
                        style: "float-label",
                        isMulti: false,
                        tooltip: true,
                        path: "/admGroup/getTypes?pick=true"
                      }
                    }
                  ]
                },

                columns: [
                  {
                    Header: "main.ID",
                    accessor: "ID",
                    maxWidth: 40
                  },
                  {
                    Header: "main.name",
                    accessor: "name"
                  },
                  {
                    Header: `${M}roleInCourse`,
                    accessor: "alterTypeName"
                  }
                ]
              };
            }
          }
          : null;
      }
    },

    columns: isCurricular
      ? [
        {
          Header: `${M}section`,
          accessor: "section"
        },
        {
          Header: `${M}mainTeacher`,
          accessor: "master"
        }
      ]
      : [
        {
          Header: "main.ID",
          accessor: "ID",
          maxWidth: 50
        },
        {
          Header: "main.name",
          accessor: "name"
        },
        {
          Header: "main.desc",
          accessor: "desc"
        },
        {
          Header: `${M}price`,
          accessor: "price"
        },
        {
          Header: "main.hour",
          accessor: "hour"
        },
        {
          Header: `${M}mainTeacher`,
          accessor: "master"
        },
        {
          Header: `${M}availableSlots`,
          accessor: "available"
        },
        {
          Header: `${M}taken`,
          accessor: "taken"
        },
        {
          Header: `${M}available`,
          accessor: "open"
        }
      ]
  };
};
